import LeftAdvertisements from "@/components/advertisements/LeftAdvertisements"
import RightAdvertisements from "@/components/advertisements/RightAdvertisements"
import EventList from "@/components/eventList/EventList"

import useIsMobile from "@/hooks/useIsMobile"
import useIsTablet from "@/hooks/useIsTablet"
import { Stack } from "@mui/material"
import { Helmet } from "react-helmet-async"

const ListPage = () => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()

  return (
    <>
      <Helmet>
        <title>843Hub | Explore Charleston | Charleston Vacation List</title>
        <meta
          name="description"
          content="Explore our event list of things to do in Charleston, SC! Charleston events & attractions this weekend. Best of Charleston food. Plan your Charleston Vacation."
        />
      </Helmet>
      <div
        className="theme-bluecontainer"
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          paddingTop: isMobile ? "0rem" : "3rem",
          paddingBottom: isMobile ? "0rem" : "3rem",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          sx={{
            width: "100%",
            justifyContent: "center",
            px: isMobile ? "0rem" : isTablet ? "1rem" : "2rem",
          }}
        >
          {!isMobile && !isTablet && <LeftAdvertisements />}
          <EventList />
          {!isMobile && <RightAdvertisements />}
        </Stack>
      </div>
    </>
  )
}

export default ListPage
